// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleOnClick() {

    this.closeModal();

}

const DebitModalHeader = props =>
    <header className='debit-modal-header'>
        <FormattedMessage
            id={`SUBMIT_${props.debitType}_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER`}
            values={{
                claimNumber: props.claimNumber
            }}
        />
        <span
            className='close-modal-icon'
            onClick={props::handleOnClick}
        />
    </header>;

DebitModalHeader.displayName = 'DebitModalHeader';
DebitModalHeader.propTypes = {
    claimNumber: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired,
    debitType: PropTypes.string.isRequired
};

export default DebitModalHeader;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/debit-modal/debit-modal-header.js